module.exports = __webpack_public_path__ + "static/media/janice_fon.e8cccdbf.jpg";